// Route paths for the Email Sequences feature (mirrors automation.constants.ts).
export const APP_EMAIL_SEQUENCES = "/settings/email-sequences";
export const APP_MANAGE_EMAIL_SEQUENCE =
  "/settings/email-sequences/manage-sequence";
export const APP_EMAIL_SEQUENCE_DETAIL =
  "/settings/email-sequences/detail";
export const APP_UPCOMING_SEQUENCE_STEPS =
  "/settings/email-sequences/upcoming";
